module.exports = __webpack_public_path__ + "img/next.f0da2bde.png";